import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const GridContainer = styled(Grid)`
  padding-top: 3.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 5px 25px #0000000d;
  border-radius: 1.2rem;
  margin: 3rem 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-left: 4rem; // Aumentado para margem lateral
  padding-right: 4rem; // Aumentado para margem lateral
`

export const GridIconCard = styled(Grid)`
  margin: 0 auto !important;
  width: auto;
`
export const GridCard = styled(Grid)`
  border-radius: 0.8rem;
  box-shadow: 0px 11px 29px #00000021;
  margin-bottom: 60px;
  margin-left: 1.5rem; // Ajustado para espaçamento entre cards
  margin-right: 1.5rem; // Ajustado para espaçamento entre cards
  max-width: 44rem; // Definido para tornar os cards um pouco menores
  width: 100%; // Para garantir que o card tente preencher o espaço do grid item até o max-width
`
export const GridCards = styled(Grid)`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 2rem;
  &:last-child {
    padding-bottom: 2rem;
  }
`
